export default __webpack_public_path__ + "static/media/icon_character_joy_ready.c54943fc.svg";